// extracted by mini-css-extract-plugin
module.exports = {"loadingIndicator":"LabelMap_loadingIndicator__zs-sP","labelMapContainer":"LabelMap_labelMapContainer__3bJug","canvasContainer":"LabelMap_canvasContainer__GszcD"};